
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconLight = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 24,
  viewBox: "0 0 20 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.988 1c3.82 0 6.989 3.253 7.012 7.246 0 2.415-1.165 4.519-2.795 5.738v1.794c0 .502-.42.909-.91.956l-6.404.527h-.094a.943.943 0 0 1-.652-.263c-.187-.167-.35-.43-.35-.693V13.96C3.932 12.646 3 10.685 3 8.246 3 4.253 6.168 1 9.988 1Zm0 1.913c-2.818 0-5.125 2.392-5.101 5.333 0 1.96.745 3.395 2.352 4.352a.99.99 0 0 1 .42.837v1.841l4.658-.382v-1.46c0-.334.163-.669.466-.836 1.468-.813 2.307-2.44 2.33-4.352 0-2.941-2.306-5.333-5.125-5.333Z",
  fill: "#000"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m13.226 19.796-6.36.478h-.07c-.488 0-.884-.383-.93-.885a.954.954 0 0 1 .861-1.028l6.36-.478a.918.918 0 0 1 1.001.884.954.954 0 0 1-.862 1.029ZM11.2 22.809l-2.283.19h-.07c-.49 0-.885-.382-.932-.884a.954.954 0 0 1 .862-1.028l2.306-.191a.926.926 0 0 1 .979.884.953.953 0 0 1-.862 1.029ZM13.692 8.222c-.046.43-.396.765-.815.765h-.07a.825.825 0 0 1-.722-.909c.14-1.363-1.025-1.865-1.165-1.913a.87.87 0 0 1-.489-1.076c.14-.43.606-.67 1.025-.502.862.31 2.446 1.483 2.236 3.635Z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"20\" height=\"24\" viewBox=\"0 0 20 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M9.98828 1C13.8086 1 16.9767 4.25262 17 8.24609C16.9999 10.6609 15.8354 12.7648 14.2051 13.9844V15.7783C14.205 16.2805 13.7851 16.6866 13.2959 16.7344L6.89062 17.2607H6.79688C6.56396 17.2607 6.30756 17.1654 6.14453 16.998C5.95826 16.8307 5.79506 16.5676 5.79492 16.3047V13.9609C3.93164 12.6458 3.00011 10.6849 3 8.24609C3 4.25264 6.16801 1.00004 9.98828 1ZM9.98828 2.91309C7.16965 2.91309 4.86342 5.30479 4.88672 8.24609C4.88684 10.2066 5.63218 11.6412 7.23926 12.5977C7.51874 12.7889 7.65913 13.0999 7.65918 13.4346V15.2764L12.3174 14.8936V13.4346C12.3174 13.0999 12.4805 12.765 12.7832 12.5977C14.2506 11.7847 15.0899 10.1589 15.1133 8.24609C15.1133 5.30483 12.8069 2.91316 9.98828 2.91309Z\" fill=\"#000000\"/>\r\n<path d=\"M13.2261 19.7958L6.86672 20.274H6.79684C6.30765 20.274 5.91164 19.8914 5.86506 19.3893C5.81847 18.8632 6.21447 18.4088 6.72695 18.361L13.0864 17.8827C13.6221 17.8349 14.0647 18.2414 14.088 18.7675C14.1346 19.2936 13.7386 19.7479 13.2261 19.7958Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n<path d=\"M11.1996 22.8086L8.91677 22.9999H8.84688C8.3577 22.9999 7.96169 22.6173 7.9151 22.1152C7.86851 21.5891 8.26452 21.1347 8.777 21.0869L11.0832 20.8956C11.5956 20.8717 12.0382 21.2543 12.0615 21.7804C12.1081 22.3065 11.7121 22.7608 11.1996 22.8086Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n<path d=\"M13.6923 8.22173C13.6457 8.65217 13.2963 8.98695 12.877 8.98695H12.8071C12.3645 8.93912 12.0384 8.5326 12.085 8.07825C12.2247 6.71521 11.06 6.21304 10.9202 6.16521C10.5009 5.99782 10.2913 5.51956 10.4311 5.08912C10.5708 4.65869 11.0367 4.41956 11.456 4.58695C12.3179 4.89782 13.9019 6.06956 13.6923 8.22173Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icon-light.5662c87c6b4a209b95556869c4f2ffaf.svg"),
        {
          React: SvgIconLight,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      